import { getGmtOffsetLabel, getTimezoneLabel } from '../../../components/TimezoneSelector/utils'
import { type BookingClient } from '../../../models/Scheduling'

// Nameless clients fall back to their email's local part ("emilia.matthews21", never the full address).
export const clientDisplayName = (client: BookingClient): string =>
  [client.firstName, client.lastName].filter((part): part is string => part != null && part !== '').join(' ') || client.email?.split('@')[0] || 'Client'

export const clientKey = (client: BookingClient): string => client.contactId ?? client.email ?? ''

export interface BrandColorOption {
  name: string
  hex: string
}

export const BRAND_COLOR_PRESETS: BrandColorOption[] = [
  { name: 'Zocks purple', hex: '#7749F8' },
  { name: 'Blue', hex: '#1F4ED8' },
  { name: 'Sky', hex: '#0EA5E9' },
  { name: 'Green', hex: '#16A34A' },
  { name: 'Amber', hex: '#F59E0B' },
  { name: 'Yellow', hex: '#F5E500' },
  { name: 'Red', hex: '#DC2626' },
  { name: 'Pink', hex: '#DB2777' },
  { name: 'Slate', hex: '#334155' },
]

export const brandColorName = (hex: string) => BRAND_COLOR_PRESETS.find((preset) => preset.hex.toLowerCase() === hex.toLowerCase())?.name ?? 'Custom'

export const formatTimezoneLabel = (ianaTimezone: string) => `${getGmtOffsetLabel(ianaTimezone)} ${getTimezoneLabel(ianaTimezone)}`
